import React from "react";
import { Trans } from "react-i18next";
import { t } from "js/i18n";
export function BillingPromoTermsMessage() {
    return (
        <Trans
            i18nKey="By applying you agree to the <promoTermsLink>Promotion Terms and Conditions</promoTermsLink>"
            components={{ promoTermsLink: <a href="/promotion-terms" target="_blank" /> }}
        />
    );
}
